import { useEffect } from 'react';
import { storage } from '@abyss/ui/tools/storage';
import { useRouter } from '@abyss/ui/router/hooks/useRouter';
import { useParams } from '@abyss/ui/router/hooks/useParams';

export const Redirect = () => {
  const { token } = useParams();
  const router = useRouter();

  useEffect(() => {
    const url = atob(decodeURIComponent(token));
    storage.session.set('redirect', url);
    router.replace('/');
  }, []);

  return null;
};
